// removed by extract-text-webpack-plugin
module.exports = {"app-header":"_1Xr7I"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Header/styles.css
 ** module id = 159
 ** module chunks = 1
 **/